import { QueryClient } from '@tanstack/react-query';

/** Align with backend analyticsResponseCache TTL (45s). */
export const FACULTY_STALE_TIME_MS = 45_000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: FACULTY_STALE_TIME_MS,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
